// extracted by mini-css-extract-plugin
export var closeButton = "_3g-3";
export var header = "_3g-0";
export var link = "_3g-1";
export var retryButton = "_3g-2";